var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/~/core-js/modules/_core.js
// module id = ../../../../core-js/modules/_core.js
// module chunks = 0